.list {
  border-radius:var(--border-radius-medium);
  border: 1px solid var(--content-border-color);
}

.item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 6.4rem;
  padding: 1.6rem;

  &:not(:last-child) {
    border-bottom: 1px solid var(--content-border-color);
  }
}
